type VehicleVendorInformation = {
  providedMileage?: number | null
  providedFRE?: string | null
  providedEstimation?: string | null
  priceReserve: number | null
  priceReserveExclVat?: string | null
  providedVehicleDescription?: string | null
  referenceVendeur?: string | null
}
const defaultVehicleVendorInformation: VehicleVendorInformation = {
  providedMileage: null,
  providedFRE: null,
  providedEstimation: null,
  priceReserve: null,
  priceReserveExclVat: null,
  providedVehicleDescription: null,
  referenceVendeur: null,
}

export type { VehicleVendorInformation }
export { defaultVehicleVendorInformation }
